import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    backgroundColor: '#fff',
  },
  tags: {
    flexDirection: 'row',
    marginBottom: 10,
    gap: 10,
  },
  tag: {
    padding: 4,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 8,
  },
  header: {
    marginBottom: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#f6f6f6',
    padding: 10,
    borderRadius: 4,
  },
  headerText: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#bfbfbf',
  },
  tableHeader: {
    backgroundColor: '#f0f0f0',
  },
  tableCell: {
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: '#bfbfbf',
    fontSize: 8,
    textAlign: 'center',
  },
  sizesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  }
});

const columns = [
  { header: 'SI.No', key: 'SNo', width: '5%' },
  { header: 'Item No', key: 'item_no', width: '8%' },
  { header: 'Kanban No', key: 'kanban_no', width: '9%' },
  { header: 'PO No', key: 'po_no', width: '10%' },
  { header: 'Line No', key: 'line_no', width: '6%' }, 
  { header: 'EOL ID', key: 'eol_id', width: '8%' },
  { header: 'Dispatch Area', key: 'dispatch_area', width: '10%' },
  { header: 'Bin ID', key: 'bin_id', width: '10%' },
  { header: 'Size', key: 'size_name', width: '8%' },
  { header: 'Quantity', key: 'quantity', width: '6%' },
  { header: 'Color', key: 'color', width: '8%' },
  { header: 'Added By', key: 'added_by', width: '6%' },
  { header: 'Added Date', key: 'added_on', width: '6%' },
];


const DownloadPdf = ({ reportData, startDate, endDate }) => {
  const formatSize = (sizeStr) => {
    try {
      return Object.entries(JSON.parse(sizeStr));
    } catch {
      return [];
    }
  };

  const formatDate = (dateStr) => {
    try {
      return new Date(dateStr).toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).replace(',', '');
    } catch {
      return dateStr;
    }
  };

  const formatHeaderDate = (dateStr) => {
    try {
      return new Date(dateStr).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    } catch {
      return dateStr;
    }
  };

  const getTotalQuantity = () => reportData.reduce((sum, row) => sum + parseInt(row.quantity || 0), 0);

  const rowsPerPage = 13;
  const totalPages = Math.ceil(reportData.length / rowsPerPage);
  const pageSize = [842, 600];

  return (
    <Document>
      {[...Array(totalPages)].map((_, pageIndex) => (
        <Page key={pageIndex} size={pageSize} style={styles.page}>
          <View style={styles.header}>
            <Text style={styles.headerText}>Production Report</Text>
          </View>
          <View style={styles.tags}>
            <View style={styles.tag}><Text>Total Records: {reportData.length}</Text></View>
            <View style={styles.tag}><Text>Total Quantity: {getTotalQuantity()}</Text></View>
            <View style={styles.tag}><Text>Period: {formatHeaderDate(startDate)} - {formatHeaderDate(endDate)}</Text></View>
          </View>
          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]} fixed>
              {columns.map((column) => (
                <View key={column.key} style={[styles.tableCell, { width: column.width }]}> 
                  <Text>{column.header}</Text>
                </View>
              ))}
            </View>
            {reportData.slice(pageIndex * rowsPerPage, (pageIndex + 1) * rowsPerPage).map((row) => (
              <View key={row.SNo} style={styles.tableRow}>
                {columns.map((column) => (
                  <View key={column.key} style={[styles.tableCell, { width: column.width }]}> 
                    {column.key === 'size_name' ? (
                      <View style={styles.sizesContainer}>
                        {formatSize(row[column.key]).map(([size, quantity], index) => (
                          <View key={index} style={styles.tag}>
                            <Text>{size}: {quantity}</Text>
                          </View>
                        ))}
                      </View>
                    ) : (
                      <Text>
                        {column.key === 'added_on' ? formatDate(row[column.key]) : row[column.key]}
                      </Text>
                    )}
                  </View>
                ))}
              </View>
            ))}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default DownloadPdf;
